import { createContext } from "react";

export interface IGridContext {
  setPageIndex: (index: number) => void;
  pageIndex: number;
  pageCount: number;
}

export const GridContext = createContext<IGridContext>({
  setPageIndex: (_: number) => undefined,
  pageIndex: 0,
  pageCount: 0,
});
